// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';

import { isEmpty } from 'lodash';
import { Route } from 'react-router-dom';
import { AppContext } from '../helpers/api-helpers';

function ProtectedRoute({
  component: Component,
  unauthorized,
  authorizedGroups,
  requireAuth = true,
  ...rest
}) {
  const UnauthorizedComponent = unauthorized || (() => 'Unauthorized');

  if (!Component) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <AppContext.Consumer>
          {({ authState, user }) => {
            if (requireAuth) {
              switch (authState) {
                default:
                case 'loading':
                  return null;
                case 'signIn':
                  return (
                    <SignedOut>
                      <RedirectToSignIn />
                    </SignedOut>
                  );
                case 'signedIn': {
                  const isAuthorized =
                    isEmpty(authorizedGroups) ||
                    (user.groups &&
                      authorizedGroups.some((group) =>
                        user.groups.includes(group),
                      ));

                  if (!isAuthorized) {
                    return <UnauthorizedComponent />;
                  }

                  return (
                    <>
                      <SignedIn>
                        <Component {...(props.match || {}).params} {...props} />
                      </SignedIn>
                      <SignedOut>
                        <RedirectToSignIn />
                      </SignedOut>
                    </>
                  );
                }
              }
            } else {
              return <Component {...(props.match || {}).params} {...props} />;
            }
          }}
        </AppContext.Consumer>
      )}
    />
  );
}

export default ProtectedRoute;
